import { createContext } from 'react';

import { ICategoryContext } from 'types/pages/audience-builder/shared/context';

export const CategoryContext = createContext<ICategoryContext | undefined>(undefined);
